import { CommunityApp } from '@atlassian/learning-components';

export const getAppByRoute = (route: string) => {
  if (route === '/events') {
    return CommunityApp.EVENTS;
  }
  if (route === '/champions') {
    return CommunityApp.CHAMPIONS;
  }
  return CommunityApp.HOME;
};
